import { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { Row } from 'reactstrap';

import { goBack } from '../../../services/navigation/navigation-service';
import Button from '../button/button';
import { withWhiteLabelContext } from 'react-whitelabel';

class PlayerDashboardButtons extends Component {
  render() {
    const { player, activePage, isTherapistRole, label } = this.props;

    const { daylyProgressDislpay } = label.playerDashboardButtons;
    const dashboard = `/player/${player.id}/dashboard`;
    const isGoBack = activePage === 'back';

    let playerName = player && player.name;
    playerName = playerName && playerName.split(' ')[0];
    if (!player.id) {
      return <div></div>;
    }

    return (
      <Row className="mx-1 my-1 p-0 text-left">
        <div className="" style={{ width: 25 }}>
          <icon
            className={`pl-1 align-middle fa fa-arrow-left ${isGoBack ? 'pointer' : 'opacity-fade-heavy'}`}
            onClick={() => isGoBack && goBack()}
          />
        </div>

        <NavLink
          to={{
            pathname: dashboard,
            player: player,
          }}
        >
          <Button
            size="sm"
            text="Overview"
            color="info"
            outline={activePage !== 'overview'}
            disabled={activePage === 'overview'}
          />
        </NavLink>

        <NavLink
          to={{
            pathname: `/player/${player.id}/sessionBank`,
            returnRoute: dashboard,
            player: player,
          }}
        >
          <Button
            size="sm"
            text={`${playerName ? `${playerName}'s` : ''} Sessions`}
            className="ml-1"
            color="info"
            outline={activePage !== 'sessionBank'}
            disabled={activePage === 'sessionBank'}
          />
        </NavLink>

        <NavLink
          to={{
            pathname: `/player/${player.id}/gameSession`,
            player: player,
            returnRoute: dashboard,
          }}
        >
          <Button
            size="sm"
            className="ml-1"
            text="Design Session"
            color="info"
            outline={activePage !== 'sessionDesigner'}
            disabled={activePage === 'sessionDesigner'}
          />
        </NavLink>

        {daylyProgressDislpay && (
          <NavLink
            to={{
              pathname: `/player/${player.id}/progressDashboard`,
              player: player,
              returnRoute: dashboard,
            }}
          >
            <Button
              size="sm"
              className="ml-1"
              text="Daily Progress"
              color="info"
              outline={activePage !== 'progressDashboard'}
              disabled={activePage === 'progressDashboard'}
            />
          </NavLink>
        )}

        <NavLink
          to={{
            pathname: `/player/${player.id}/sessions`,
            returnRoute: dashboard,
            player: player,
          }}
        >
          <Button
            size="sm"
            text="Session Data"
            className="ml-1"
            color="info"
            outline={activePage !== 'playerGameSessions'}
            disabled={activePage === 'playerGameSessions'}
          />
        </NavLink>
        <NavLink
          to={{
            pathname: `/player/${player.id}/activities`,
            returnRoute: dashboard,
            player: player,
          }}
        >
          <Button
            size="sm"
            text="Activity Data"
            className="ml-1"
            color="info"
            outline={activePage !== 'activities'}
            disabled={activePage === 'activities'}
          />
        </NavLink>
        {isTherapistRole && (
          <NavLink
            to={{
              pathname: `/player/${player.id}/teamMembers`,
              returnRoute: dashboard,
              player: player,
            }}
          >
            <Button
              size="sm"
              text="Team Members"
              className="ml-1"
              color="info"
              outline={activePage !== 'playerTeamMembers'}
              disabled={activePage === 'playerTeamMembers'}
            />
          </NavLink>
        )}

        {isTherapistRole && (
          <NavLink
            to={{
              pathname: `/player/${player.id}/homePlay`,
              returnRoute: dashboard,
              player: player,
            }}
          >
            <Button
              size="sm"
              text="Home Play"
              className="ml-1"
              color="info"
              outline={activePage !== 'homePlay'}
              disabled={activePage === 'homePlay'}
            />
          </NavLink>
        )}
      </Row>
    );
  }
}

export default withWhiteLabelContext(PlayerDashboardButtons);
